import QRCode from "qrcode";
import React, { useRef, useCallback } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import styles from "assets/jss/material-kit-react/components/headerStyle.js";
import brandImage from "assets/img/iese-logo-navbar.png";

import { useTranslation } from 'react-i18next';

import { withRouter } from "react-router-dom";
import axios from "axios";
import EmailSendModal from "components/MyComponents/EmailSendModal";
import { toPng } from 'html-to-image';
const useStyles = makeStyles(styles);

function DigitalIdCard(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    const [emailSendModalOpen, setEmailSendModalOpen] = React.useState(false);
    const canvasRef = useRef();
    const [userData, setUserData] = React.useState({
        name: undefined,
        surname: undefined,
        program: undefined,
        initials: undefined,
        isnotsubscribed: true
    });
    React.useEffect(() => {
        if (props.userData) {
            setUserData({
                ...userData,
                ['name']: props.userData.name,
                ['surname']: props.userData.surname,
                ['program']: props.userData.program,
                ['initials']: (props.userData.name ? props.userData.name.charAt(0).toUpperCase() : "") + (props.userData.surname ? props.userData.surname.charAt(0).toUpperCase() : ""),
                ['isnotsubscribed']: props.userData.isnotsubscribed
            });
        }
    }, []);
    React.useEffect(() => {
        async function fetchDigitalIdentityData() {
            const res = await fetch("/personalinfo/getidentity");
            res.text().then(res => {
                QRCode.toCanvas(
                    canvasRef.current,
                    // QR code doesn't work with an empty string
                    // so we are using a blank space as a fallback
                    res || " ", { width: 105, height: 105 },
                    (error) => error && console.error(error)
                );
            });
        }
        fetchDigitalIdentityData();
    }, []);
    const getPassbookByEmail = () => {
        axios.get('/personalinfo/getpassbookbyemail')
            .then(() => {
                setEmailSendModalOpen(true);
                return;
            }).catch(function (error) {
                if (error.response !== undefined && error.response.status !== null && error.response.status === 400) {
                    document.getElementById("info").style.visibility = "visible";
                }
                else {
                    document.getElementById("error").style.visibility = 'visible';
                }
            });
    }
    const cardref = React.createRef();
    const getDigitalCardImage = useCallback(() => {
        if (cardref.current === null) {
          return
        }
    
        toPng(cardref.current, { cacheBust: true, })
          .then((dataUrl) => {
            const link = document.createElement('a')
            link.download = 'mydigitalid.png'
            link.href = dataUrl
            link.click()
          })
          .catch((err) => {
            console.log(err)
          })
      }, [cardref])

      const isWebView = function () { 
        if (typeof window === undefined) { return false };
            let navigator = window.navigator;

            const standalone = navigator.standalone;
            const userAgent = navigator.userAgent.toLowerCase();
            const safari = /safari/.test(userAgent);
            const ios = /iphone|ipod|ipad|macintosh/.test(userAgent);
            const ios_ipad_webview = ios && !safari;
        
            return ios ? ( (!standalone && !safari) || ios_ipad_webview ) : userAgent.includes('wv');
        }

    const isWebViewFlag = isWebView();
      

    return (
        <div className={classes.digitalIdCenteredDiv}>
            <div ref={cardref} id="DigitalIdCard" className={classes.digitalIdCardWrapper}>
                <div style={{ padding: "24px" }}>
                    <div className={classes.flexSpaceBetween} style={{ paddingBottom: "10px" }}>
                        <div className={classes.digitalIdLeftWrapperColumn}>
                            <img style={{ filter: "brightness(0) invert(1)", width: "175px" }}
                                src={brandImage}
                                className={classes.img}
                                alt="brand"
                            />
                            <div>
                                <div className="cl-secondary-100 regular-b500">{(userData.name ? userData.name : "")}</div>
                                <div className="cl-secondary-100 regular-b500">{(userData.surname ? userData.surname : "")}</div>
                            </div>
                        </div>
                        <div>
                            <canvas width={105} height={105} style={{ borderRadius: "5.67442px" }} ref={canvasRef} />
                        </div>
                    </div>
                    {/* <div className={classes.flexSpaceBetween} style={{ paddingBottom: "10px" }}>
                        <div>
                            <img style={{ filter: "brightness(0) invert(1)", width: "150px" }}
                                src={brandImage}
                                className={classes.img}
                                alt="brand"
                            />
                        </div>
                        <div>
                            <canvas width={61} height={61} style={{ borderRadius: "5.67442px" }} ref={canvasRef} />
                        </div>
                    </div>
                    <div className={classes.flexSpaceBetween + " " + classes.flexAlignItemsCenter}>
                        <div>
                            <div className="cl-secondary-100 regular-b500">{(userData.name ? userData.name : "")}</div>
                            <div className="cl-secondary-100 regular-b500">{(userData.surname ? userData.surname : "")}</div>
                        </div>
                        <div style={{ textAlign: "right" }}>
                            <div className="cl-secondary-100 regular-b50" style={{ paddingBottom: "7px" }}>{t("Header_DigitalIdentity_AcademicYear")}</div>
                            <div className="cl-secondary-100 regular-b500">{(new Date() > new Date('31/08/' + new Date().getFullYear())) ? new Date().getFullYear() + 1 : new Date().getFullYear()}</div>
                        </div>
                    </div> */}
                </div>
                <div>
                    <svg width="110%" viewBox="0 0 72 13" style={{ marginLeft: "-15.69px", marginBottom: "-7px" }}><text x="0" y="13" fontWeight="600" fill="white" opacity="0.3">MEMBER</text></svg>
                </div>
            </div>
            <div className={classes.spacing}></div>
            <div className="paddingBottom16" style={{ paddingTop: "34px" }}>
                { isWebViewFlag ? null : <a target="_blank" href="/personalinfo/getpassbook">
                    <img width="165" src="/img/addtowallet.svg" />
                </a>}
                <a className='semibold-b300 anchor' style={{ paddingLeft: "24px" }}
                    onClick={() => getPassbookByEmail()}>
                    {t("Header_DigitalIdentity_PassbookByEmail")}<img loading="lazy"
                        className="gotopageimg"
                        alt={t("Header_DigitalIdentity_PassbookByEmail")} src="/img/rightarrow.svg" /></a>
                {/* <a style={{ paddingLeft: "24px" }} target="_blank" href="/personalinfo/getgooglewallet">
								<img height={46} src="/img/google-wallet-button.png" />
            </a>
            <a style={{ paddingLeft: "24px" }} target="_system" href="/personalinfo/getidentityimage">
                <img src="/img/downloadqr.svg" />
            </a> */}
            { isWebViewFlag ? null : 
            <a style={{ paddingLeft: "24px", cursor: "pointer" }} onClick={() => getDigitalCardImage()}>
                <img src="/img/downloadqr.svg" />
            </a>}
            </div>
            <EmailSendModal show={emailSendModalOpen} close={() => setEmailSendModalOpen(false)} />
        </div>
    );
}
export default withRouter(DigitalIdCard);